import { FC, useEffect } from 'react';

import { CloseButton } from '../../../shared/ui';

interface MeetChatImageLightboxProps {
  imageSrc: string | null;
  onClose: () => void;
}

export const MeetChatImageLightbox: FC<MeetChatImageLightboxProps> = ({ imageSrc, onClose }) => {
  useEffect(() => {
    if (!imageSrc) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [imageSrc, onClose]);

  if (!imageSrc) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-modal flex items-center justify-center bg-black/85 p-2 pt-[max(8px,env(safe-area-inset-top,0px))] pb-[max(8px,env(safe-area-inset-bottom,0px))] sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Просмотр изображения"
      onClick={onClose}
    >
      <CloseButton tone="inverse" className="absolute right-3 top-3 sm:right-4 sm:top-4 m-1" onClick={onClose} />

      <img
        src={imageSrc}
        alt="Изображение из чата"
        className="max-h-full max-w-full object-contain"
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};
